module.exports = __webpack_public_path__ + "static/image2-1a8e95bcc592c04ca8bb2aeec8cec492.png";